export const environment = {
	production: true,
	useProxy: false,
	buildType: 'prod',
	style: 'white'
};
